export default __webpack_public_path__ + "static/media/assembly_7.13fdf8e3.png";